import { roomBatchCreateSchema } from '@super-mega/server/contracts/room'
import type { RoomBatchFormValues } from './room-batch-modal.tsx'

export type RoomGenerationValues = Omit<RoomBatchFormValues, 'siteId' | 'status' | 'note'>
function padNumber(value: number, width: number) {
  return String(value).padStart(width, '0')
}

function buildRangeRooms(values: RoomGenerationValues) {
  const start = values.startNumber ?? 1
  const end = values.endNumber ?? start
  const width = Math.max(1, values.padStart ?? 1)
  if (!Number.isSafeInteger(start) || !Number.isSafeInteger(end) || start < 1 || end < start) {
    throw new Error('请填写有效的整数编号区间，结束编号不能小于起始编号')
  }
  if (end - start + 1 > 500) {
    throw new Error('单次最多生成 500 个房间')
  }
  if (!Number.isInteger(width) || width > 10) {
    throw new Error('编号补零位数应为 1 至 10 的整数')
  }
  const rooms: Array<{ roomNo: string; area: number | null }> = []
  for (let number = start; number <= end; number += 1) {
    rooms.push({
      area: values.area ?? null,
      roomNo: `${values.prefix ?? ''}${padNumber(number, width)}${values.suffix ?? ''}`
    })
  }
  return rooms
}

function buildListRooms(values: RoomGenerationValues) {
  return (values.listText ?? '')
    .split(/[\n;；]+/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [roomNo, areaText] = line.split(/[\t\s,，]+/)
      const area = areaText ? Number(areaText) : (values.area ?? null)
      return { area, roomNo }
    })
}

export function buildRooms(values: RoomGenerationValues) {
  const rooms = values.mode === 'range' ? buildRangeRooms(values) : buildListRooms(values)
  const result = roomBatchCreateSchema.shape.rooms.safeParse(rooms)
  if (!result.success) {
    throw new Error(result.error.issues[0]?.message ?? '请检查房间编号与面积')
  }
  return result.data
}
